import { FC } from 'react';

import styles from './ProProfileClientVerificationBadge.module.scss';

const TRANSLATIONS = {
  en: {
    governmentIdBadgeText: 'ID',
    mailBadgeText: 'Email Address',
    phoneBadgeText: 'Phone Number',
  },
  ja: {
    governmentIdBadgeText: '本人確認',
    mailBadgeText: 'メール認証',
    phoneBadgeText: '電話番号',
  },
};

interface Props {
  language: 'en' | 'ja';
  verifiedBadges: { governmentId: boolean; mail: boolean; phone: boolean };
}

const ProProfileClientVerificationBadge: FC<Props> = ({ language, verifiedBadges }) => {
  const { governmentId, phone, mail } = verifiedBadges;

  return (
    <div className={styles['verification-badges']}>
      <div className={styles['verification-badges-child']}>
        <img
          alt={`Government Id ${governmentId ? 'verified' : 'unverified'}`}
          src={`/static/images/icons/govt-id-verification-${
            governmentId ? 'on-with-check' : 'off'
          }.svg`}
        />
        <span className={styles['verification-badges-child-text']}>
          {TRANSLATIONS[language].governmentIdBadgeText}
        </span>
      </div>
      <div className={styles['verification-badges-child']}>
        <img
          alt={`Phone number ${phone ? 'verified' : 'unverified'}`}
          src={`/static/images/icons/phone-verification-${phone ? 'on-with-check' : 'off'}.svg`}
        />
        <span className={styles['verification-badges-child-text']}>
          {TRANSLATIONS[language].phoneBadgeText}
        </span>
      </div>
      <div className={styles['verification-badges-child']}>
        <img
          alt={`Email ${mail ? 'verified' : 'unverified'}`}
          src={`/static/images/icons/mail-verification-${mail ? 'on-with-check' : 'off'}.svg`}
        />
        <span className={styles['verification-badges-child-text']}>
          {TRANSLATIONS[language].mailBadgeText}
        </span>
      </div>
    </div>
  );
};

export default ProProfileClientVerificationBadge;
export type { Props as ProProfileClientVerificationBadgeProps };
